import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/Button";

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="text-7xl font-bold text-muted-foreground">404</div>
      <p className="mt-2 text-lg">That page doesn&apos;t exist (yet).</p>
      <Link to="/" className="mt-6">
        <Button>Back to dashboard</Button>
      </Link>
    </div>
  );
}
